import allRoutes from '@/router/routes/all.js'
import publicRoutes from '@/router/routes/public.js'
import privateRoutes from '@/router/routes/private.js'
import contentRoutes from '@/router/routes/content.js'
import consultantRoutes from "@/router/routes/consultant.js";
import settingRoutes from '@/router/routes/setting.js'
import patientRoutes from '@/router/routes/patient/index.js'
import medicalRoutes from '@/router/routes/patient/madical.js'
import partnerRoutes from '@/router/routes/partner.js'
import reportRoutes from '@/router/routes/report.js'
import stockRoutes from '@/router/routes/stock.js'
import purchaseRoutes from '@/router/routes/purchase.js'
import masterRoutes from '@/router/routes/master.js'
import penjualanPosRoutes from '@/router/routes/penjualanPos.js'
import elearningRoutes from '@/router/routes/kelas.js'
import mobilePatientRoutes from '@/router/routes/mobile/patient/index.js'
import mobileMedicalRoutes from '@/router/routes/mobile/patient/madical.js'
import ecommerceRoutes from '@/router/routes/e-commerce.js'
import akeRoutes from '@/router/routes/ake.js'

export default allRoutes.concat(
  publicRoutes,
  privateRoutes,
  contentRoutes,
  consultantRoutes,
  settingRoutes,
  patientRoutes,
  medicalRoutes,
  partnerRoutes,
  reportRoutes,
  stockRoutes,
  purchaseRoutes,
  masterRoutes,
  penjualanPosRoutes,
  elearningRoutes,
  mobilePatientRoutes,
  mobileMedicalRoutes,
  ecommerceRoutes,
  akeRoutes
)